module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAPCAYAAAAGRPQsAAABY0lEQVQ4T53TPWgUQBDF8d8DCxEVbUTTCCoiiiDYicYuKgRtRZA0QRQr7SRqJaZIYSeohRBsBFHLhPRaCOJXsEllFztT+rWyYROO8+5IstXCvP3Pm5mdQCnlWJIP9d7vlFIO4ClONs0i7uAFLuFbSinbsISRJHO9YKWUnfiCoR7x35jGVIUdxadqEBNJJrsflFLu41Yf179aoicVth3V8uYmfo8KfJXkT2vDa1wY0IXLSZ6liR/iWpf4O2bwGedxagBsd5LF6uwQzmEchwcNoU+stmdHkqUK29LK3LoBUH3yNcmyiZUyJ3Bvg7AHSW6uwlrfbuA69q8TWv/ox25Y/YB1YsfXAZtNcnZFv1xmc7YPb7FrjbCfOJJk4T9YA+7FbZxYw2QvJnnemXjVWYfDM7jbgD23C1eTPO4O1q8x0pZ3D4ZxcECZ87iS5E0vTYVtwijGcBp1qTvPD7zDI7xM8rdfsn8VtW/lpvwiwAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tt.png
// module id = p32T
// module chunks = 1